export const EMAIL_REGEX: RegExp = /^\S+@\S+\.\S+$/;
export const HTML_ENTITY_REGEX: RegExp = /&(?:#(?:(?<dec>[0-9]+)|[Xx](?<hex>[0-9A-Fa-f]+))|(?<named>[A-Za-z0-9]+));/;
